export default class NavBase
{
    constructor( header, mediaQuery ){
        this.header = header;
        this.$el = this.header.$el;
        this.mq = window.matchMedia( mediaQuery );
        this.enabled = false;
        this.mq.addListener(changed => this.toggle(changed.matches));
        this.init();
        this.toggle( this.mq.matches );
    }

    init(){}
    enable(){}
    disable(){}

    toggle( on ){
        if( on === undefined ){
            on = !this.enabled;
        }
        if( !on && this.enabled ){
            this.enabled = false;
            this.disable();
        }
        else if( on ){
            this.enabled = true;
            this.enable();
        }
    }
    
}